import React from 'react';

import { View, Pressable} from "react-native-web";
import CustomText from "./CustomText";
import { useResponsive } from "../../hooks/useResponsive";
import { spacing, colors, borderRadius } from "../../utils/styling";

interface SocialCardProps {
  iconPath: string;
  socialCompany: string;
  selected?: boolean;
  onPress?: (social: string) => void;
}

export default function SocialCard({ iconPath, socialCompany, selected = false, onPress }: SocialCardProps) {
  const { isMobile } = useResponsive();

  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }: { pressed: boolean }) => ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingHorizontal: isMobile ? spacing.sm : spacing.lg,
        backgroundColor: selected
          ? colors.gray[300]
          : pressed
          ? colors.gray[200]
          : colors.gray[100],
        borderColor: selected
          ? colors.gray[700]
          : colors.gray[100],
        borderWidth: 1,
        borderRadius: borderRadius.xl,
        minHeight: 75,
        width: '100%',
        transition: '0.1s ease-out'
      })}
    >
      <img
        alt={`${socialCompany} Logo`}
        src={iconPath}
        style={{
          width: 40,
          height: 'auto'
        }}
      />
      <CustomText style={{
        fontFamily: "Nunito",
        fontSize: isMobile ? 18 : 24,
        fontWeight: 500,
        textAlign: isMobile ? 'center' : 'left',
        marginLeft: isMobile ? spacing.sm : spacing.md,
      }}>
        {socialCompany}
      </CustomText>
    </Pressable>
  );
}